export const STRINGS = {
  title: "“Need help? Let's pick up where we left\u00a0off!”",
  showMore: 'SHOW MORE',
  showLess: 'SHOW LESS',
  chatInProgress: 'Chat In Progress',
  closed: 'Chat Closed',
  closeIssue: 'CLOSE ISSUE',
  areYouSure: 'Are you sure you want to close this\u00a0conversation?',
  cannotBeUndone: 'This action cannot be\u00a0undone.',
  yesCloseIt: 'Yes, Close It',
  noDontCloseIt: "No, Don't Close it",
  conversationClosed:
    'Your conversation with Phin was successfully\u00a0closed.',
  errorClosingConversation:
    'There was an error closing your\u00a0conversation.',
};
